import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Text, Button, Spacer, useTheme, Card, Badge } from "@geist-ui/core";
import { useMediaQuery } from "@mui/material";
import { Mail, LogOut, Send } from "@geist-ui/icons";
import { BrandLogo } from "../../components/brand-logo";
import API_CLIENT from "../../utility/api-client";
import { AppContext } from "../portal/auth-router";
import TagManager from "react-gtm-module";
import { sha256 } from "js-sha256";
import Normalizer from "../../utility/normalizer";
import MultistepForm from "../../components/vertical-multistep-form/multistep-form";
import MultistepFormBody from "../../components/vertical-multistep-form/multistep-form-body";
import MultistepFormNavigation from "../../components/vertical-multistep-form/multistep-form-navigation";
import PrimaryButton from "../../components/input-elements/buttons";

export default function ForceEmailVerification() {
  const { getAccessTokenSilently, logout } = useAuth0();
  const [token, setToken] = useState("");
  const [mailSent, setMailSent] = useState(false);

  useEffect(() => {
    const getToken = async () => {
      try {
        const accessToken = await getAccessTokenSilently({});
        setToken(accessToken);
      } catch(e) {}
    };
    getToken();
  }, [getAccessTokenSilently]);

  return (
    <MultistepForm style={{ height: "100vh" }}>
      <MultistepFormNavigation>
        <Box
          sx={{ display: { xs: "none", md: "flex" } }}
          style={{ width: "100%", justifyContent: "center" }}
        >
          <a href="https://www.inventure.de/">
            <img
              src={process.env.REACT_APP_LOGO_LIGHT}
              style={{ height: "60px", margin: "40px auto" }}
            />
          </a>
        </Box>
      </MultistepFormNavigation>
      <MultistepFormBody>
        <div style={{ overflow: "hidden", width: "800px" }}>
          <div
            style={{
              textAlign: "left",
              padding: "0 10px 0 10px",
            }}
          >
            <Typography
              variant="h4"
              style={{
                fontWeight: 600,
                marginTop: "20px",
                marginBottom: "20px",
                fontFamily: "'Nunito Sans', sans-serif",
              }}
            >
              Herzlich Willkommen
            </Typography>

            <Typography variant="body1" style={{ marginTop: "0px" }}>
              Dein Account wurde erfolgreich erstellt. Wir haben eine Nachricht
              an deine E-Mail Adresse gesendet.{" "}
              <b>
                Bitte überprüfe deine E-Mails, um deine Registrierung
                abzuschließen.
              </b>{" "}
              Überprüfe bitte auch deinen Spam-Ordner, falls du keine E-Mail
              finden solltest. Wir freuen uns dich im Anschluss auf unserer
              Investmentplattform willkommen zu heißen.
            </Typography>
            <div
              style={{
                marginTop: "50px",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <PrimaryButton
                disabled={mailSent}
                onClick={() => {
                  API_CLIENT.resendVerificationMail(
                    token,
                    () => {
                      setMailSent(true);
                    },
                    () => console.log("error")
                  );
                }}
                style={{ minWidth: "250px", marginRight: "50px" }}
              >
                E-Mail erneut versenden
              </PrimaryButton>
              <Typography
                sx={{
                  marginTop: { xs: "20px", md: "0" },
                  width: { xs: "100%", md: "250px" },
                  marginLeft: { xs: "0px", md: "50px" },
                }}
                variant="body1"
                onClick={() => logout({ returnTo: window.location.origin })}
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                Logout
              </Typography>
            </div>
            {mailSent ? (
              <Typography variant="body1" style={{ fontWeight: 700, marginTop: '20px' }}>
                Verifizierungsmail erfolgreich versandt.
              </Typography>
            ) : null}
          </div>
        </div>
      </MultistepFormBody>
    </MultistepForm>
  );
}

export function ForceEmailVerificationV2() {
  const { getAccessTokenSilently, logout, user: auth0User } = useAuth0();
  const context = useContext(AppContext);
  const history = useHistory();
  const [token, setToken] = useState("");
  const [mailSent, setMailSent] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const getToken = async () => {
      try {
        const accessToken = await getAccessTokenSilently({});
        setToken(accessToken);
      } catch (e) {
        console.error(e);
      }
    };
    getToken();
  }, [getAccessTokenSilently]);

  // Polling for email verification status via Backend API
  useEffect(() => {
    const checkVerification = async () => {
      try {
        if (!token) return;
        API_CLIENT.getUser(
            token,
            (user) => {
                if (user.communication && user.communication.email_confirmed) {
                    window.location.reload();
                }
            },
            () => {} // ignore errors
        );
      } catch (e) {
        // Ignore errors during polling
      }
    };

    const intervalId = setInterval(checkVerification, 3000); // Check every 3 seconds
    return () => clearInterval(intervalId);
  }, [token]);

  const e_mail = context.user?.communication.email || auth0User?.email || "";

  // GTM Tracking
  useEffect(() => {
    const signed_up = localStorage.getItem("signed-up");
    if (signed_up !== "true" && e_mail) {
      TagManager.dataLayer({
        dataLayer: {
          event: "signup",
          event_id: sha256(e_mail),
          email: sha256(Normalizer.normalizeMail(e_mail)),
        },
      });
      localStorage.setItem("signed-up", "true");
    }
  }, [e_mail]);

  const isMobile = useMediaQuery('(max-width:900px)');

  return (
    <div style={{ display: 'flex', minHeight: '100vh', width: '100%', background: '#fff', overflow: 'hidden', flexDirection: isMobile ? 'column' : 'row' }}>
        {/* Left Column: Form & Info */}
        <div style={{ 
            flex: isMobile ? '1 1 auto' : '0 0 620px', 
            padding: isMobile ? '32px 24px' : '60px 80px', 
            position: 'relative', 
            zIndex: 10, 
            background: '#fff', 
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center' 
        }}>
            <div style={{ position: 'absolute', bottom: '-40px', left: '-40px', zIndex: -1, opacity: 0.05, fontFamily: '"Nunito Sans", sans-serif', userSelect: 'none', pointerEvents: 'none' }}>
                <div style={{ fontSize: '320px', fontWeight: 900, letterSpacing: '-0.05em', lineHeight: 0.8, color: '#000' }}>inventure.</div>
            </div>

            <div style={{ maxWidth: '440px', width: '100%' }}>
                <div style={{ marginBottom: '80px' }}>
                    <BrandLogo fontSize="32px" onClick={() => history.push("/")} style={{ cursor: 'pointer' }} />
                </div>

                <Text small style={{ color: '#888', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: '12px' }}>
                    E-Mail Bestätigung
                </Text>
                <Text h1 style={{ fontSize: '48px', fontWeight: 900, letterSpacing: '-0.04em', lineHeight: 1.1, marginBottom: '40px', fontFamily: "'Nunito Sans', sans-serif" }}>
                    <i style={{ fontStyle: 'italic' }}>Fast</i> geschafft.
                </Text>

                {/* Vertical Stepper - Step 2 Active */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0', marginBottom: '60px', position: 'relative' }}>
                    <div style={{ 
                        position: 'absolute', 
                        left: 0,
                        width: '32px',
                        display: 'flex',
                        justifyContent: 'center',
                        top: '40px', 
                        height: 'calc(100% - 80px)', 
                        zIndex: 0
                    }}>
                        <div style={{ 
                            width: '2px', 
                            height: '100%',
                            background: 'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.05) 100%)',
                        }}></div>
                    </div>
                    
                    {[
                        { s: "1", t: "Account erstellt", a: true, c: true, d: "Daten erfolgreich hinterlegt" }, 
                        { s: "2", t: "E-Mail bestätigen", a: true, c: false, d: "Link in deinem Postfach" }, 
                        { s: "3", t: "Investieren", a: false, c: false, d: "Zugang zu Top-VCs" }
                    ].map((item, i) => (
                        <div 
                            key={i} 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'flex-start', 
                                gap: '20px', 
                                transition: 'all 0.3s ease',
                                padding: '16px 0',
                                position: 'relative',
                                zIndex: 1
                            }}
                        >
                            <div style={{ 
                                width: '32px', 
                                height: '32px', 
                                borderRadius: '50%', 
                                background: item.c 
                                    ? '#e5e5e5' 
                                    : (i === 1 ? 'linear-gradient(135deg, #000 0%, #333 100%)' : '#fff'),
                                color: i === 1 ? '#fff' : '#ccc', 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                fontSize: '14px', 
                                fontWeight: 900,
                                boxShadow: i === 1 ? '0 4px 12px rgba(0,0,0,0.15)' : 'none',
                                border: i === 1 ? 'none' : '2px solid #e5e5e5',
                                transition: 'all 0.3s ease',
                                position: 'relative',
                                zIndex: 2,
                                boxSizing: 'border-box',
                                flexShrink: 0
                            }}>
                                {item.s}
                            </div>
                            <div style={{ flex: 1 }}>
                                <Text span style={{ 
                                    fontWeight: 700, 
                                    fontSize: '18px',
                                    display: 'block',
                                    marginBottom: '4px',
                                    color: i === 1 ? '#000' : (item.c ? '#999' : '#ccc'),
                                    opacity: item.a ? 1 : 0.5
                                }}>
                                    {item.t}
                                </Text>
                                <Text span style={{ 
                                    fontSize: '14px',
                                    color: i === 1 ? '#666' : '#ccc',
                                    display: 'block',
                                    opacity: item.a ? 1 : 0.5
                                }}>
                                    {item.d}
                                </Text>
                            </div>
                        </div>
                    ))}
                </div>

                <div style={{ width: '100%' }}>
                    <Card style={{ border: '1px solid #eaeaea', background: '#fafafa', padding: '24px', borderRadius: '16px', marginBottom: '32px' }}>
                        <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                            <div style={{ background: '#000', color: '#fff', padding: '10px', borderRadius: '12px' }}>
                                <Mail size={20} />
                            </div>
                            <div>
                                <Text h4 style={{ margin: 0, fontWeight: 800 }}>Postfach prüfen</Text>
                                <Text p style={{ color: '#666', fontSize: '14px', lineHeight: 1.5, marginTop: '8px', marginBottom: 0 }}>
                                    Bestätigungsmail gesendet an: <br/>
                                    <strong style={{ color: '#000' }}>{e_mail}</strong>
                                </Text>
                            </div>
                        </div>
                    </Card>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <Button 
                            onClick={() => window.location.reload()}
                            style={{ 
                                borderRadius: '100px', 
                                fontWeight: 800, 
                                height: '56px', 
                                background: '#000', 
                                color: '#fff',
                                width: '100%'
                            }}
                        >
                            Ich habe die E-Mail bestätigt
                        </Button>

                        <div style={{ display: 'flex', gap: '16px' }}>
                            <Button 
                                onClick={() => {
                                    API_CLIENT.resendVerificationMail(
                                        token,
                                        () => setMailSent(true),
                                        () => console.log("error")
                                    );
                                }}
                                disabled={mailSent}
                                style={{ 
                                    borderRadius: '100px', 
                                    fontWeight: 800, 
                                    height: '56px', 
                                    background: '#fff', 
                                    color: '#000',
                                    border: '1px solid #eaeaea',
                                    flex: 1
                                }}
                            >
                                {mailSent ? 'Gemailt ✓' : 'Erneut senden'}
                            </Button>
                            <Button 
                                onClick={() => logout({ returnTo: window.location.origin })}
                                style={{ 
                                    borderRadius: '100px', 
                                    fontWeight: 800, 
                                    height: '56px', 
                                    background: '#fff', 
                                    color: '#000', 
                                    border: '1px solid #eaeaea',
                                    flex: 1
                                }}
                            >
                                Abmelden
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Right Column: Branding */}
        {!isMobile && (
        <div style={{ flex: 1, background: '#000', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '80px', textAlign: 'center', position: 'relative' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: 0.15 }}>
                <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0 100 L100 0 L100 100 Z" fill="url(#gradAuthRedesign)" /><defs><linearGradient id="gradAuthRedesign" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style={{ stopColor: '#333' }} /><stop offset="100%" style={{ stopColor: '#000' }} /></linearGradient></defs></svg>
            </div>
            <div style={{ position: 'relative', zIndex: 10 }}>
                <Text span style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '28px', fontStyle: 'italic', color: 'rgba(255,255,255,0.7)', display: 'block', marginBottom: '12px' }}>In wenigen Momenten in der</Text>
                <Text h1 style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '90px', color: '#fff', fontWeight: 900, letterSpacing: '-0.05em', lineHeight: 0.85, margin: 0, textTransform: 'uppercase' }}>CHAMPIONS <br/><i style={{ fontStyle: 'italic' }}>LEAGUE</i></Text>
                <Text span style={{ fontSize: '28px', color: 'rgba(255,255,255,0.7)', display: 'block', marginTop: '12px' }}>des Venture Capitals.</Text>
            </div>
        </div>
        )}
    </div>
  );
}
